import Vue from "vue";
import router from '../router';
import VueGtag from "vue-gtag";
import utils from './../utils';

let idGoogleAnalytics = '';
switch (utils.loadCountry()) {
  case 'CO':
    idGoogleAnalytics = 'G-VSXSM2WCZY';
    break;
  case 'EC':
    idGoogleAnalytics = 'G-1DV0ZWV7Z9';
    break;
  case 'UY':
    idGoogleAnalytics = 'G-GFWNYHS0CS';
    break;
  default:
    idGoogleAnalytics = 'G-GFWNYHS0CS';
    break;
}

Vue.use(VueGtag, {
  config: { id: idGoogleAnalytics }
}, router);
